<template>
    <v-container>
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="font-weight-bold mt-10 title-page">Minha Conta</div>
                    <!-- <div v-if="user" class="button-group"> -->
                    <div class="button-group">
                        <v-btn type="button" elevation="0" color="primary" to="conta-procurador-editar">Editar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/home">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <br />

        <div class="mt-4" v-if="dataset.loading">
            <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
        </div>

        <div v-if="!dataset.loading" v-html="!user ? dataset.contentUserAnonymous : ''"></div>

        <v-row v-if="user">
      
            <v-col cols="12">
                <v-card class="card-form-outlined">
                    <v-card-title class="card-group-title">Detalhes</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <span class="main-text"> {{ dataset.data ? dataset.data.name : '' }} </span>
                                <div class="caption-text">NOME COMPLETO</div>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <span class="main-text"> {{ dataset.data ? dataset.data.phone_number : '' }} </span>
                                <div class="caption-text">TELEFONE</div>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <span class="main-text"> {{ dataset.data ? formatCpfCnpj(dataset.data.registration) : '' }} </span>
                                <div class="caption-text">CPF/CNPJ</div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <span class="main-text"> {{ dataset.data ? dataset.data.email : '' }} </span>
                                <div class="caption-text">EMAIL</div>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <span class="main-text"> {{ dataset.data ? dataset.data.federal_registration : '' }} </span>
                                <div class="caption-text">OAB</div>
                            </v-col>
                             <v-col cols="12" sm="4">
                                <span class="main-text"> {{ dataset.data ? dataset.data.federal_registration_uf : '' }} </span>
                                <div class="caption-text">OAB UF</div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="user">
     
            <v-col cols="12">
                <v-card class="card-form-outlined">
                    <v-card-title class="card-group-title">Endereço</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <span class="main-text"> {{ dataset.data ? dataset.data.address_postal_code : '' }} </span>
                                <div class="caption-text">CEP</div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <span class="main-text"> {{ dataset.data ? dataset.data.address_street : '' }} </span>
                                <div class="caption-text">RUA/AVENIDA</div>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="4">
                                <span class="main-text"> {{ dataset.data ? dataset.data.address_number : '' }} </span>
                                <div class="caption-text">NÚMERO</div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <span class="main-text"> {{ dataset.data ? dataset.data.address_complement : '' }} </span>
                                <div class="caption-text">COMPLEMENTO</div>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="4">
                                <span class="main-text"> {{ dataset.data ? dataset.data.address_neighborhood : '' }} </span>
                                <div class="caption-text">BAIRRO</div>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <span class="main-text"> {{ dataset.data ? dataset.data.address_city : '' }} </span>
                                <div class="caption-text">CIDADE</div>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <span class="main-text"> {{ dataset.data ? dataset.data.address_state : '' }} </span>
                                <div class="caption-text">ESTADO</div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        
        <v-row v-if="user">
      
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Ações</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <v-row>
                                    <v-col>
                                        <v-btn type="button" elevation="0" color="primary" outlined
                                            :href="dataset.data && dataset.data.documentUrl" target="_blank">Visualizar documento
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n3">
                                    <v-col>
                                        <iframe :src="dataset.data && dataset.data.documentUrl" width="250" height="150" frameborder="0"
                                            scrolling="no" class="rounded-xl"></iframe>
                                        <div class="caption-text">DOCUMENTO</div>
                                    </v-col>
                                </v-row>
                            </v-col>
                          
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
import 'moment/locale/pt-br'
import { eventHub } from '@/main'
import { cpf, cnpj } from 'cpf-cnpj-validator'
import axios from 'axios'

export default {
  data: () => ({
    user: null,
    loading: false,
    isRegistrationCNPJ: null,
    dataset: {
      contentUserAnonymous: '',
      contentUserLogged: '',
      loading: false,
      data: {
      }
    },
    selectedDoc: null,
    dialogViewDoc: false,
  }),

  created() {
    this.$ga.event({
      eventCategory: 'page',
      eventAction: 'action',
      eventLabel: 'click',
      eventValue: 'user-area'
    })

    this.loadData()
  },

  methods: {

    async loadData() {
      this.dataset.loading = true

      try {

        await this.loadText()

        this.user = this.$root.user || null

        if (this.user) {
          await this.loadLawyerData()
        }
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      } finally {
        this.dataset.loading = false
      }
    },

    async loadText() {
      const result = await axios.get(`/api/dynamic-infos/keys`, {
        params: { keys: 'user-event-anonymous,user-event-logged' }
      })

      if (!result.data.content) return

      let contentUserAnonymous = result.data.content.find((x) => x.key === 'user-event-anonymous')
      let contentUserLogged = result.data.content.find((x) => x.key === 'user-event-logged')

      this.dataset.contentUserAnonymous = contentUserAnonymous ? contentUserAnonymous.value : ''
      this.dataset.contentUserLogged = contentUserLogged ? contentUserLogged.value : ''
    },

    async checkAccess() {
      try {
        const response = await axios.get(`/api/users/check-access`)
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$router.replace('/minha-conta')
          return
        }

        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      }
    },

    openDoc(doc) {
      window.open(doc, '_blank')
    },

    async loadLawyerData() {

      try {

      const result = await axios.get('/api/lawyers/my-account')
      
      this.dataset.data = result.data.content.data
   
      } catch (error) {
        console.error('Erro ao carregar informações do procurador:', error)
      }

    },

    formatCpfCnpj(value) {
      if (!value) {
          return ''
      }
      return value.length == 14 ? cnpj.format(value) : cpf.format(value);
    },

  }
}
</script>

<style lang="scss">
.title-page {
  color: var(--v-primary-base);
  font-family: 'Raleway';
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
}

.section-info-title {
  color: var(--v-primary-base);
  font-family: 'Raleway';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}

.section-info-value {
  font-family: 'Raleway';
  font-size: 14px;
  font-style: normal;
}

.custom-panel-header {
  min-height: 20px !important;
  line-height: 20px !important;
  padding-top: 5 !important;
  padding-bottom: 0 !important;
}

.main-text {
  font-size: 16px;
  /* Tamanho do texto principal */
  color: #000;
  /* Cor do texto */
}

.caption-text {
  font-size: 12px;
  /* Tamanho da legenda menor */
  font-weight: bold;
  /* Negrito na legenda */
  color: #444;
  /* Cor da legenda */
  margin-top: -5px;
  /* Ajuste de espaçamento entre texto e legenda */
}
</style>